export default __webpack_public_path__ + "static/media/tashkent2.756a3fbd.jpg";